import React from 'react';
import MyInput from "../../shared/form/MyInput";
import MyTextArea from "../../shared/form/MyTextArea";

const MONTHS = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre",
  "Noviembre", "Diciembre"];
const DAYS_IN_MONTH = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const pad = n => String(n).padStart(2, "0");

// "MM-DD HH:mm" <-> { month, day, time }
const parseStart = (start = "") => {
  const [date = "01-01", time = "00:00"] = start.split(" ");
  const [month = "01", day = "01"] = date.split("-");
  return { month, day, time };
};
const formatStart = ({ month, day, time }) => `${month}-${day} ${time}`;

const SeasonCard = ({ title, season, isActive, onChange }) => {
  const start = parseStart(season.start);
  const maxDay = DAYS_IN_MONTH[parseInt(start.month, 10) - 1] || 31;

  const changeStart = (field, value) => {
    const next = { ...start, [field]: value };
    const nextMaxDay = DAYS_IN_MONTH[parseInt(next.month, 10) - 1];
    if (parseInt(next.day, 10) > nextMaxDay) next.day = pad(nextMaxDay);
    onChange("start", formatStart(next));
  };

  const schedule = season.schedule || [];
  const scheduleLine = (index, lang) => (schedule[index] && schedule[index][lang]) || "";

  return (
    <div className="card mb-4">
      <div className="card-header d-flex justify-content-between align-items-center bg-primary text-white">
        <span className="ff-bobby" style={{ fontSize: "24px" }}>{title}</span>
        {isActive && <span className="badge badge-light">ACTIVO HOY</span>}
      </div>
      <div className="card-body container-fluid">
        <div className="row mb-1">Empieza cada año el</div>
        <div className="row mb-3">
          <div className="col-5 pl-0">
            <select className="form-control form-control-lg" value={start.month}
                    onChange={e => changeStart("month", e.target.value)}>
              {MONTHS.map((name, index) => <option key={name} value={pad(index + 1)}>{name}</option>)}
            </select>
          </div>
          <div className="col-3">
            <select className="form-control form-control-lg" value={start.day}
                    onChange={e => changeStart("day", e.target.value)}>
              {Array.from({ length: maxDay }, (_, i) => pad(i + 1)).map(day =>
                <option key={day} value={day}>{parseInt(day, 10)}</option>
              )}
            </select>
          </div>
          <div className="col-4 pr-0">
            <input type="time" className="form-control form-control-lg" value={start.time} required
                   onChange={e => e.target.value && changeStart("time", e.target.value)}/>
          </div>
        </div>

        <MyInput title="Horario corto (barra superior) - Español" name="scheduleLight.es"
                 value={(season.scheduleLight && season.scheduleLight.es) || ""}
                 onChange={e => onChange("scheduleLight.es", e.target.value)}/>
        <MyInput title="Horario corto (barra superior) - Inglés" name="scheduleLight.en"
                 value={(season.scheduleLight && season.scheduleLight.en) || ""}
                 onChange={e => onChange("scheduleLight.en", e.target.value)}/>

        {[0, 1].map(index => (
          <React.Fragment key={index}>
            <MyTextArea title={`Horario completo, línea ${index + 1} (footer y contacto) - Español`}
                        name={`schedule.${index}.es`} value={scheduleLine(index, "es")}
                        onChange={e => onChange(`schedule.${index}.es`, e.target.value)}/>
            <MyTextArea title={`Horario completo, línea ${index + 1} (footer y contacto) - Inglés`}
                        name={`schedule.${index}.en`} value={scheduleLine(index, "en")}
                        onChange={e => onChange(`schedule.${index}.en`, e.target.value)}/>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SeasonCard;
